import { useState } from "react";
import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import { Grid, IconButton, Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

const AccordionStyled = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '10px !important',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ExpandCircleDownOutlinedIcon sx={{ fontSize: '1.5rem', color: "#ff5504" }} />}
        {...props}
    />
))(({ theme }) => ({
    color: "#1e456c",

    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: '8px',
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
}));

interface props {
    children: React.ReactNode,
    header?: string,
    SubHeader?: any,
    props?: AccordionSummaryProps,
    onClink?: any,
    onExpanded?: boolean, //false = เปิด หรือ true = ปิด ไว้
    isShowHelper?: boolean,
    onOpenHelper?: any,
}


const Accordion: React.FC<props> = ({ children, header, props, onExpanded, SubHeader, isShowHelper, onOpenHelper }) => {
    const [expanded, setExpanded] = useState(true);
    const [action, setAction] = useState(SubHeader != null ? true : false);

    const handleChange = ()=> {
        setExpanded(!expanded);
    };

    return (
        <AccordionStyled
            {...props}
            expanded={expanded}
        >
            <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                expandIcon={
                    <span onClick={() => { handleChange() }} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <ExpandCircleDownOutlinedIcon sx={{ fontSize: '1.5rem', color: "#ff5504" }} />
                    </span>
            }
                sx={{
                    color: "#1e456c",
                    cursor:'default !important',
                    flexDirection: 'row-reverse',
                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                        transform: 'rotate(180deg)',
                    },
                    '& .MuiAccordionSummary-content': {
                        marginLeft: '8px',
                    },
                    alignItems: SubHeader ? "start" : "center",
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        margin: SubHeader ? "12px 0" : "0"
                    }
                }}
                
            >
                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center">
                    <Grid item xs={'auto'}>
                        <span onClick={()=>{handleChange()}} style={{cursor:'pointer'}}>
                            <Typography>{header}</Typography>
                        </span>
                    </Grid>
                    {
                        isShowHelper
                            ?
                            <Grid item xs={'auto'}>
                                <Tooltip title={"ข้อมูลเพิ่มเติม"} >
                                <IconButton style={{color:'#05a6e8'}} onClick={() => { if (onOpenHelper) { onOpenHelper() } }}>
                                    <InfoIcon />
                                </IconButton>
                                </Tooltip>
                                
                            </Grid>
                            : null
                    }
                </Grid>
            </AccordionSummary>

            {action == true ?
                <AccordionDetails>
                    {SubHeader}
                </AccordionDetails>
                :
                <AccordionDetails>
                    {children}
                </AccordionDetails>
            }

        </AccordionStyled>

    )
}

export default Accordion